import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Table, Card } from "react-bootstrap";
import { ShimmerTable } from "react-shimmer-effects";
import { ToastContainer, toast } from "react-toastify";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import moment from "moment";
import { FaPhoneAlt } from "react-icons/fa";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import jwt_decode from "jwt-decode";

const CallHistory = ({ socket, selectedWhatsAppSetting }) => {
  const [callLogs, setCallLogs] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [userInfo, setUserInfo] = useState(
    jwt_decode(sessionStorage.getItem("token"))
  );
  const formatPhoneNumber = (number) => {
    const shouldHideNumber =
      userInfo?.userrole === "USER" &&
      userInfo?.is_whatsapp_number_hidden === true;

    if (shouldHideNumber && number) {
      // Keep last 5 digits visible, mask the rest with X
      const numberString = String(number);
      if (numberString.length <= 5) {
        return numberString; // Show all if number is 5 digits or less
      }
      const visibleDigits = numberString.slice(-5);
      const maskedDigits = "X".repeat(numberString.length - 5);
      return `${maskedDigits}${visibleDigits}`;
    }
    return number;
  };

  useEffect(() => {
    fetchCalls(selectedWhatsAppSetting);
  }, [selectedWhatsAppSetting]);

  const fetchCalls = async (selectedWhatsAppSetting) => {
    try {
      const res = await WhatsAppAPI.getCallLogs(selectedWhatsAppSetting); // API function should return your given data
      if (res.success) {
        const formattedCallLogs = res.records.map((log) => ({
          ...log,
          display_whatsapp_number: formatPhoneNumber(log.whatsapp_number),
        }));
        setCallLogs(formattedCallLogs);
      } else {
        toast.error("Failed to fetch call logs");
      }
    } catch (err) {
      toast.error("Error fetching call logs");
    }
    setIsLoaded(true);
  };

  const formatUnix = (unixTime) => {
    if (!unixTime || unixTime === "Not answered") return "Not answered";
    return moment.unix(Number(unixTime)).format("DD MMM YYYY hh:mm:ss A");
  };

  const getDuration = (start, end) => {
    if (!start || !end) return "-";
    const duration = Number(end) - Number(start);
    const mins = Math.floor(duration / 60);
    const secs = duration % 60;
    return `${mins}m ${secs}s`;
  };

  const headers = [
    {
      title: "Name",
      prop: "name",
      isFilterable: true,
    },
    {
      title: "WhatsApp Number",
      prop: "whatsapp_number",
      cell: (row) => (
        <span>
          {row.display_whatsapp_number ||
            formatPhoneNumber(row.whatsapp_number)}
        </span>
      ),
    },
    {
      title: "Status",
      prop: "status",
      cell: (row) => <span className="text-primary">{row.status || "-"}</span>,
    },
    {
      title: "Start Time",
      prop: "start_time",
      cell: (row) => formatUnix(row.start_time),
    },
    {
      title: "End Time",
      prop: "end_time",
      cell: (row) =>
        row.end_time ? (
          formatUnix(row.end_time)
        ) : (
          <span className="text-danger">Not Answered</span>
        ),
    },
    {
      title: "Duration",
      prop: "duration",
      cell: (row) => getDuration(row.start_time, row.end_time),
    },
  ];

  const labels = { beforeSelect: " " };

  return (
    <>
      <Container className="mt-5 mb-5">
        <Row className="mx-5 mb-4">
          <Card className="p-4 bg-white shadow-sm border-0 rounded-3">
            <h5 className="mb-2 fw-bold">💡 Quick Guide</h5>
            <small>
              View all incoming and outgoing WhatsApp call activities. Duration
              is calculated only if end time is available.
            </small>
          </Card>
        </Row>

        <Row className="mx-5 g-0">
          <Col lg={12} className="mb-3">
            <div className="bg-white shadow-sm border-0 rounded-3 p-4">
              <h5 className="fw-semibold mb-1">
                <FaPhoneAlt className="me-2" />
                Call History
              </h5>

              {isLoaded ? (
                <DatatableWrapper
                  body={callLogs}
                  headers={headers}
                  paginationOptionsProps={{
                    initialState: { rowsPerPage: 10, options: [5, 10, 15, 20] },
                  }}
                >
                  <Row className="mb-3">
                    <Col
                      lg={3}
                      sm={10}
                      xs={10}
                      className="d-flex flex-col justify-content-end align-items-end"
                    >
                      <Filter className="p-2" />
                    </Col>
                    <Col
                      lg={4}
                      sm={2}
                      xs={2}
                      className="d-flex flex-col justify-content-start align-items-start"
                    >
                      <PaginationOptions labels={labels} />
                    </Col>
                    <Col
                      lg={5}
                      sm={12}
                      xs={12}
                      className="mt-2 d-flex flex-col justify-content-end align-items-end"
                    ></Col>
                  </Row>

                  <div className="table-responsive">
                    <Table
                      striped
                      bordered
                      className="related-list-table"
                      responsive="sm"
                    >
                      <TableHeader />
                      <TableBody />
                    </Table>
                  </div>
                  <Pagination />
                </DatatableWrapper>
              ) : (
                <ShimmerTable row={10} col={6} />
              )}
            </div>
          </Col>
        </Row>
      </Container>

      <ToastContainer />
    </>
  );
};

export default CallHistory;
